export interface Article {
  id: string;
  title: string;
  category: string;
  date: string;
  summary: string;
  content: string;
  author: string;
  image: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2025年最值得期待的十部国产大片，每一部都不容错过',
    category: '影视资讯',
    date: '2025-07-28',
    summary: '盘点今年下半年即将上映的国产大片，从科幻到动作，从喜剧到悬疑，类型丰富多样，每一部都值得期待。',
    author: '影评人小王',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20article%20cover%20image%20showing%20a%20collection%20of%20Chinese%20movie%20posters%20arranged%20on%20a%20dark%20wall%2C%20theater%20lights%20illuminating%20them%2C%20warm%20golden%20and%20red%20tones%2C%20professional%20editorial%20photography%2C%20cinematic%20atmosphere&width=1200&height=630&seq=article-cover-01&orientation=landscape',
    content: `2025年对于中国电影市场来说，注定是不平凡的一年。随着国产电影工业的不断成熟，越来越多的优秀作品涌现出来。

下半年即将上映的影片中，科幻题材的《星际迷途》无疑是最大看点之一。导演郭帆继《流浪地球》系列后，再次挑战太空题材，据悉影片的特效制作达到了好莱坞顶级水准。

在动作片领域，《暗夜追踪》凭借刘德华和张震的黄金搭档组合，以及惊险刺激的追车场面，已经吸引了大量关注。预告片上线首日播放量就突破了五千万。

喜剧片方面，沈腾和马丽这对黄金搭档再度联手，《欢乐一家人》以家庭温情为主题，让观众在笑声中感受亲情温暖。

动画电影《龙之传说》则在视觉呈现上达到了新的高度，融合了中国传统美术风格与现代3D技术，被业内称为"国漫新标杆"。

总的来说，2025年的国产电影无论是数量还是质量都令人期待，让我们一起走进电影院，支持国产佳片！`,
  },
  {
    id: 'article-2',
    title: '《大秦风云》热播背后：历史剧为何能再次征服观众？',
    category: '剧集点评',
    date: '2025-07-25',
    summary: '《大秦风云》播出以来收视率持续走高，豆瓣评分高达9.0。这部历史剧的成功密码是什么？',
    author: '剧评人老张',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20drama%20article%20cover%2C%20ancient%20Chinese%20palace%20architecture%20with%20dramatic%20lighting%2C%20warriors%20in%20traditional%20armor%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20editorial%20photography%2C%20epic%20and%20majestic&width=1200&height=630&seq=article-cover-02&orientation=landscape',
    content: `近期，《大秦风云》的热度持续不减，在各大社交平台上，关于剧情的讨论层出不穷。一部历史剧为何能够在当下获得如此高的关注度？

首先，《大秦风云》在制作上的精益求精功不可没。从服装道具到场景搭建，每一个细节都力求还原历史真实。据悉，剧组花费了整整两年时间进行前期筹备工作，仅服装就制作了超过三千套。

其次，演员阵容的强大也是重要因素。陈道明饰演的秦始皇霸气外露，将一代帝王的雄才大略与人性弱点都展现得淋漓尽致。张丰毅和孙俪的加盟也为剧集增色不少。

此外，剧本的扎实程度令人赞叹。编剧团队查阅了大量历史文献，在尊重史实的基础上，赋予了角色丰富的内心世界和情感层次。

最重要的是，这部剧触及了当代观众关心的核心议题——个人与集体的关系、理想与现实的碰撞，这些普世主题让历史剧焕发出新的生命力。

总的来说，《大秦风云》的成功并非偶然，它是中国电视剧工业化水准提升的一个缩影。`,
  },
  {
    id: 'article-3',
    title: '国产动画的春天：《龙之传说》刷新票房纪录',
    category: '影视资讯',
    date: '2025-07-20',
    summary: '《龙之传说》上映首周票房突破15亿，不仅刷新了国产动画电影的票房纪录，更展现了国漫的无限潜力。',
    author: '影评人小王',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20animation%20film%20article%20cover%2C%20a%20beautiful%20dragon%20illustrated%20in%20traditional%20Chinese%20ink%20painting%20style%20blended%20with%20modern%20digital%20art%2C%20vibrant%20colors%2C%20golden%20and%20jade%20tones%2C%20professional%20editorial%20composition&width=1200&height=630&seq=article-cover-03&orientation=landscape',
    content: `《龙之传说》在上映首周就创造了惊人的票房成绩，15亿的数字让业界为之震惊。这部动画电影的成功，标志着国产动画已经进入了一个全新的发展阶段。

影片由饺子导演执导，他是中国动画电影的代表人物之一。从《哪吒》到《龙之传说》，饺子的每一部作品都在突破自我。

《龙之传说》最大的亮点在于其独特的美学风格。影片将中国传统水墨画的意境与现代3D动画技术完美融合，创造出了一种前所未见的视觉体验。片中的龙形象既有东方神韵，又不失现代感。

在故事层面，影片以少年成长为主线，融入了友情、勇气、责任等多重主题，既有热血沸腾的战斗场景，也有温馨感人的情感时刻。

更值得关注的是，影片的受众群体非常广泛，从儿童到成年观众都能在片中找到共鸣点。这正是国产动画走向成熟的标志——不再局限于低幼市场，而是成为全民共享的文化产品。

随着《龙之传说》的成功，我们有理由相信，中国动画电影的未来会更加精彩。`,
  },
  {
    id: 'article-4',
    title: '如何在家打造影院级观影体验？成全影院为你支招',
    category: '观影指南',
    date: '2025-07-15',
    summary: '不用去电影院，在家也能享受沉浸式观影。从设备选择到环境布置，成全影院为你整理了一份完整指南。',
    author: '编辑小李',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20home%20theater%20setup%20in%20a%20modern%20living%20room%2C%20large%20TV%20screen%20with%20movie%20playing%2C%20comfortable%20sofa%20with%20blankets%2C%20dim%20warm%20ambient%20lighting%2C%20popcorn%20and%20drinks%2C%20professional%20interior%20photography%2C%20inviting%20atmosphere&width=1200&height=630&seq=article-cover-04&orientation=landscape',
    content: `在忙碌的生活中，窝在沙发上看一部好电影，无疑是放松身心的最佳方式之一。如何让家庭观影体验更上一层楼？成全影院为你整理了以下建议。

首先，画质是观影体验的核心。建议选择支持4K分辨率的电视或投影仪，这样才能还原电影导演最初的视觉意图。目前市面上性价比较高的品牌有海信、TCL和小米等。

其次，音响系统同样重要。一套好的音响能让爆炸声更有冲击力，让对话更清晰。如果预算有限，一条回音壁也能显著提升音质体验。

环境布置方面，遮光窗帘是必备品。即使是白天观影，拉上窗帘就能营造出影院的氛围。再备上几盏可调亮度的壁灯或落地灯，打造温馨的观影环境。

舒适度也不容忽视。一张柔软的大沙发，几个靠垫，一条薄毯，就能让你舒舒服服地度过两个小时的电影时光。

最后，别忘了准备观影零食！一碗热腾腾的爆米花，一杯冰镇饮料，让观影体验更加完美。

在成全影院，我们为你精选了海量高清影视作品，无论你偏好哪种类型，都能在这里找到心仪的内容。打开成全影院，开启你的私人影院之旅吧！`,
  },
  {
    id: 'article-5',
    title: '悬疑剧迷必看：《迷雾深林》中的十大未解之谜',
    category: '剧集点评',
    date: '2025-07-10',
    summary: '《迷雾深林》以其错综复杂的剧情和出人意料的转折吸引了大量观众，剧中埋藏了哪些悬而未解的谜团？',
    author: '剧评人老张',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20foggy%20forest%20scene%20for%20an%20article%20cover%2C%20tall%20pine%20trees%20partially%20hidden%20in%20mist%2C%20a%20narrow%20path%20leading%20into%20darkness%2C%20moody%20and%20atmospheric%2C%20professional%20photography%2C%20cinematic%20quality&width=1200&height=630&seq=article-cover-05&orientation=landscape',
    content: `忻钰坤导演的新作《迷雾深林》自上映以来，就凭借其精巧的叙事结构和层层递进的悬疑氛围，成为了今年讨论度最高的悬疑片之一。

影片讲述了五位好友在森林探险中遭遇诡异事件的故事。随着剧情的推进，观众会发现每一个角色都隐藏着不为人知的秘密。导演巧妙地运用了多线叙事手法，让观众在拼凑碎片信息的过程中获得解谜的乐趣。

第一个谜团：森林深处的废弃小屋到底是谁建造的？小屋里发现的日记本和照片暗示着这里曾发生过什么可怕的事情。

第二个谜团：为什么五位主角的手机在进入森林后就全部失去了信号？这真的是因为地理位置偏僻，还是另有原因？

第三个谜团：最先失踪的人究竟是自己离开的，还是被迫的？如果仔细观察，会发现失踪现场留下的痕迹存在许多矛盾之处。

影片中的每一个细节都值得反复推敲。忻钰坤以其一贯的严谨风格，为观众呈现了一部需要"二刷"才能完全理解的作品。

如果你喜欢烧脑悬疑，《迷雾深林》绝对值得一看。在成全影院，你可以随时点播这部精彩的悬疑佳作。`,
  },
  {
    id: 'article-6',
    title: '成全影院使用指南：教你快速找到想看的影片',
    category: '观影指南',
    date: '2025-07-05',
    summary: '成全影院拥有海量影视资源，如何快速精准地找到心仪的影片？这份使用指南请收好。',
    author: '编辑小李',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20streaming%20platform%20interface%20on%20a%20laptop%20screen%2C%20showing%20movie%20thumbnails%20organized%20in%20a%20clean%20grid%20layout%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20clean%20and%20modern&width=1200&height=630&seq=article-cover-06&orientation=landscape',
    content: `成全影院致力于为用户提供最佳的在线观影体验。为了让您更快地找到心仪的影片，我们特别准备了这份使用指南。

首先，利用分类功能是最高效的方式。成全影院将影片按照动作、喜剧、爱情、科幻、恐怖、动画、剧情、悬疑等八大类型进行了详细分类。点击任意分类标签，即可浏览该类型下的所有影片。

其次，首页的"最新电影"和"热门剧集"板块会根据影片的上映时间和用户热度进行推荐，是发现好片的最佳入口。

对于喜欢阅读影视资讯的用户，成全影院的"影视资讯"板块每天更新最新的影视新闻、影评和观影指南，帮助您了解影视圈的最新动态。

我们还提供了丰富的筛选维度。您可以根据年份、评分来快速筛选影片。高评分影片（8.5分以上）会被特别标注，方便您快速找到口碑佳作。

在成全影院，每一部影片都标注了导演、主演、类型和简介等详细信息，让您在选择影片时能够做出最合适的决定。

现在就打开成全影院，开始您的观影之旅吧！高清画质、流畅播放、无广告干扰，尽在成全影院。`,
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getLatestArticles = (count: number = 6): Article[] => {
  return articles.slice(0, count);
};

export const getRelatedArticles = (currentId: string, count: number = 3): Article[] => {
  return articles.filter((a) => a.id !== currentId).slice(0, count);
};